import { FormItem, FormItemProps } from 'components/Form/FormItem';
import { FormattedMessage } from 'react-intl';
import { OtherMeterDetailField } from '../constants';
import { MeterDetails as messages } from '../../messages';
import { OtherDeviceCategorySelect } from '../../../../Select/meter_details/OtherDeviceCategory';

export const getOtherDetailFormItem = (field: OtherMeterDetailField, formItemProps: FormItemProps) => {
  switch (field) {
    case OtherMeterDetailField.DeviceCategory:
      return (
        <FormItem
          label={<FormattedMessage {...messages.equipmentCategory} />}
          name={['detail', 'deviceCategory']}
          {...formItemProps}
        >
          <OtherDeviceCategorySelect />
        </FormItem>
      );
    default:
      return null;
  }
};
